import { SET_INCLUDE_CASH } from './constants';

export const setIncludeCash = includeCash => ({
    type: SET_INCLUDE_CASH,
    includeCash,
});



// WEBPACK FOOTER //
// ./src/containers/common/cash/actions.js